import type { TargetAndTransition } from 'framer-motion';

export function mergeMotionVariants(
  variants: Record<string, TargetAndTransition | undefined>,
  appliedVariant?: string | string[]
): TargetAndTransition {
  if (appliedVariant === undefined) {
    return Object.entries(variants).reduce(
      (result, [, variant]) => ({ ...result, ...variant }),
      {}
    );
  }

  if (typeof appliedVariant === 'string') {
    return variants[appliedVariant] ?? {};
  }

  if (Array.isArray(appliedVariant)) {
    return appliedVariant.reduce(
      (result, variantLabel) =>
        variants[variantLabel]
          ? { ...result, ...variants[variantLabel] }
          : result,
      {}
    );
  }

  throw new Error('Expected the appliedVariant to be a string or string[]');
}
